interface DuetErrorOptions {
  cause?: unknown;
  extra?: Record<string, any>;
}

// TODO: Could add native `cause` support for modern browsers.
/**
 * DuetError allows setting `cause` and `extra`.
 */
export class DuetError extends Error {
  public cause?: unknown;

  /** This field is picked up by Sentry */
  public extra?: Record<string, any>;

  /**
   * This field is printed out by NextJS in the console logs.
   * The `extra` field is not enough because not all information
   * is being printed out to the console log.
   * e.g. `errors: [ [Object], [Object], [Object] ],`
   */
  public readonly extraStringified?: string;

  constructor(msg: string, options: DuetErrorOptions = {}) {
    super(msg);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#custom_error_types
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DuetError);
    }

    this.name = "DuetError";
    this.cause = options.cause;
    this.extra = options.extra;
    this.extraStringified = JSON.stringify(this.extra, null, 2);
  }
}
